<template>
  <div class="addadmin">
    <div class="title">
      管理员 <span>{{title}}管理员</span>
    </div>
    <div class="main">
      <div class="addAdminInfo">{{title}}管理员</div>
      <div class="adminContent">
        <div class="adminlist">
          <label for="adminname">
            <span>*</span>管理员姓名
          </label>
          <el-input size="small"
                    placeholder="请输入"
                    v-model="adminInfo.name"></el-input>
        </div>
        <div class="adminlist">
          <label for="adminname">
            <span>*</span>管理员账号
          </label>
          <el-input size="small"
                    placeholder="请输入"
                    autocomplete='off'
                    v-model="adminInfo.account"></el-input>
        </div>
        <div class="adminlist">
          <label for="type"><span>*</span>归属公司</label>
          <el-select v-model="companyId"
                     size="small"
                     @change='handleTypeChange'>
            <el-option v-for="item in companyList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="adminlist">
          <label for="company"><span>*</span>归属部门</label>
          <el-select v-model="departmentId"
                     size="small"
                     :disabled="companySelect"
                     @change='handlDepartmentChange'>
            <el-option v-for="item in officeList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="adminlist">
          <label for="company"><span>*</span>角色名称</label>
          <el-select v-model="roleId"
                     size="small"
                     :disabled="roleSelect">
            <el-option v-for="item in roleList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="adminlist">
          <label for="adminname">
            <span v-if="!id">*</span>密码
          </label>
          <el-input size="small"
                    placeholder="请输入"
                    v-model="adminInfo.password"
                    autocomplete='off'
                    show-password></el-input>
        </div>
        <div class="adminlist">
          <label for="updateStatus">
            <span>*</span>状态
          </label>
          <div class='versionRadio'>
            <el-radio v-model="adminInfo.status"
                      label='0'>正常</el-radio>
            <el-radio v-model="adminInfo.status"
                      label='1'>禁用</el-radio>
          </div>
        </div>
        <div class="adminlist">
          <label for="adminname">
            电话
          </label>
          <el-input size="small"
                    placeholder="请输入"
                    v-model="adminInfo.phone"></el-input>
        </div>
        <div class="adminlist">
          <label for="remark">备注</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="adminInfo.remarks"></el-input>
        </div>
        <div class="adminBtn">
          <button class="save"
                  @click="handleAddClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getAdminList,
  addAdminInfo,
  saveAdminInfo
} from 'apis/index'
export default {
  name: 'addadmin',
  data () {
    return {
      id: '',
      title: '添加',
      adminInfo: {
        name: '',
        account: '',
        password: '',
        status: '0',
        phone: '',
        remarks: ''
      },
      companySelect: true,
      roleSelect: true,
      companyId: '',
      departmentId: '',
      roleId: '',
      companyList: [],
      officeList: [],
      roleList: []
    }
  },
  methods: {
    getData (id) {
      // console.log(id)
      getAdminList({
        id: id
      }).then(res => {
        // console.log('list', res)
        if (res.data.code === 200) {
          this.companyList = res.data.data.sysList
          console.log('sss', res)
          if (res.data.data.userList) {
            let userinfo = res.data.data.userList[0]
            this.adminInfo.name = userinfo.name
            this.adminInfo.account = userinfo.phone
            this.adminInfo.status = String(userinfo.state)
            this.adminInfo.phone = userinfo.telephone
            this.companyId = userinfo.companyId
            this.departmentId = userinfo.departmentId
            this.roleId = userinfo.roleId
            this.companySelect = false
            this.roleSelect = false
            this.companyList.forEach(element => {
              if (element.id === this.companyId) {
                this.officeList = element.officeList
              }
            })
            this.roleList = this.officeList[0].roleList
          }
        }
      })
    },
    handleTypeChange () { // 选择公司类型
      this.departmentId = ''
      this.roleId = ''
      this.companySelect = false
      this.roleList = []
      this.companyList.forEach(element => {
        if (element.id === this.companyId) {
          this.officeList = element.officeList
        }
      })
    },
    handlDepartmentChange () { // 选择部门
      this.roleSelect = false
      this.roleId = ''

      this.officeList.forEach(element => {
        if (element.id === this.departmentId) {
          this.roleList = element.roleList
        }
      })
    },

    handleAddClick () { // 添加/保存
      if (this.id) {
        // console.log('修改')
        saveAdminInfo({
          id: this.id,
          name: this.adminInfo.name,
          phone: this.adminInfo.account,
          companyId: this.companyId,
          departmentId: this.departmentId,
          roleId: this.roleId,
          password: this.adminInfo.password,
          state: this.adminInfo.status,
          telephone: this.adminInfo.phone,
          remark: this.adminInfo.remarks
        }).then(res => {
          if (res.data.code === 200) {
            this.$router.push({ path: '/system/administrator' })
          }
        })
      } else {
        // console.log('添加')
        addAdminInfo({
          name: this.adminInfo.name,
          phone: this.adminInfo.account,
          companyId: this.companyId,
          departmentId: this.departmentId,
          roleId: this.roleId,
          password: this.adminInfo.password,
          state: this.adminInfo.status,
          telephone: this.adminInfo.phone,
          remark: this.adminInfo.remarks
        }).then(res => {
          if (res.data.code === 200) {
            this.$router.push({ path: '/system/administrator' })
          }
        })
      }
    },
    handleCancelClick () {
      this.$router.push({ path: '/system/administrator' })
    }
  },
  mounted () {
    this.id = this.$route.query.company ? this.$route.query.company : ''
    if (this.id) {
      this.title = '修改'
    }
    this.getData(this.id)
  }
}
</script>
<style lang="stylus">
.addadmin
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 45px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addAdminInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/03/add_icon.png') no-repeat center left 15px
    .adminContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .adminlist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
        .versionRadio
          height 30px
          .el-radio
            width 80px
            .el-radio__label
              color #212832
        .rate
          position relative
          left 15px
          color #f66
      .adminBtn
        margin-left 116px
        margin-top 150px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
